import { httpClient } from "../utils/HttpClient";

import {
    HTTP_MEETINGS_FETCHING,
    HTTP_MEETINGS_SUCCESS,
    HTTP_MEETINGS_FAILED,

    HTTP_MEETING_FETCHING,
    HTTP_MEETING_SUCCESS,
    HTTP_MEETING_FAILED,

    HTTP_EVENT_FETCHING,
    HTTP_EVENT_SUCCESS,
    HTTP_EVENT_FAILED,

    HTTP_DOCUMENTS_FETCHING,
    HTTP_DOCUMENTS_SUCCESS,
    HTTP_DOCUMENTS_FAILED,

    HTTP_ATTENDEES_FETCHING,
    HTTP_ATTENDEES_SUCCESS,
    HTTP_ATTENDEES_FAILED,

    HTTP_ATTACHMENTS_FETCHING,
    HTTP_ATTACHMENTS_SUCCESS,
    HTTP_ATTACHMENTS_FAILED,

    HTTP_TEMPLATES_FETCHING,
    HTTP_TEMPLATES_SUCCESS,
    HTTP_TEMPLATES_FAILED,

    HTTP_REPORT_RESPONSE_FETCHING,
    HTTP_REPORT_RESPONSE_SUCCESS,
    HTTP_REPORT_RESPONSE_FAILED    
} from "../constants/meeting";

import {
  server
} from "../constants";

const setStateMeetingsToSuccess = payload => ({
  type: HTTP_MEETINGS_SUCCESS,
  payload: payload
});

const setStateMeetingsToFetching = () => ({
  type: HTTP_MEETINGS_FETCHING
});

const setStateMeetingsToFailed = () => ({
  type: HTTP_MEETINGS_FAILED
});

const setStateMeetingToSuccess = (payload) => ({
  type: HTTP_MEETING_SUCCESS,
  payload: payload,
});

const setStateMeetingToFetching = () => ({
  type: HTTP_MEETING_FETCHING,
});

const setStateMeetingToFailed = () => ({
  type: HTTP_MEETING_FAILED,
});

const setStateEventToSuccess = (payload) => ({
  type: HTTP_EVENT_SUCCESS,
  payload: payload,
});

const setStateEventToFetching = () => ({
  type: HTTP_EVENT_FETCHING,
});

const setStateEventToFailed = () => ({
  type: HTTP_EVENT_FAILED,
});

const setStateDocumentsToSuccess = (payload) => ({
  type: HTTP_DOCUMENTS_SUCCESS,
  payload: payload,
});

const setStateDocumentsToFetching = () => ({
  type: HTTP_DOCUMENTS_FETCHING,
});

const setStateDocumentsToFailed = () => ({
  type: HTTP_DOCUMENTS_FAILED,
});

const setStateAttachmentsToSuccess = (payload) => ({
  type: HTTP_ATTACHMENTS_SUCCESS,
  payload: payload,
});

const setStateAttachmentsToFetching = () => ({
  type: HTTP_ATTACHMENTS_FETCHING,
});

const setStateAttachmentsToFailed = () => ({
  type: HTTP_ATTACHMENTS_FAILED,
});

const setStateTemplatesToSuccess = (payload) => ({
  type: HTTP_TEMPLATES_SUCCESS,
  payload: payload,
});

const setStateTemplatesToFetching = () => ({
  type: HTTP_TEMPLATES_FETCHING,
});

const setStateTemplatesToFailed = () => ({
  type: HTTP_TEMPLATES_FAILED,
});

const setStateAttendeesToSuccess = (payload) => ({
  type: HTTP_ATTENDEES_SUCCESS,
  payload: payload,
});

const setStateAttendeesToFetching = () => ({
  type: HTTP_ATTENDEES_FETCHING,
});

const setStateAttendeesToFailed = () => ({
  type: HTTP_ATTENDEES_FAILED,
});

const setStateReportResponseToSuccess = (payload) => ({
  type: HTTP_REPORT_RESPONSE_SUCCESS,
  payload: payload,
});

const setStateReportResponseToFetching = () => ({
  type: HTTP_REPORT_RESPONSE_FETCHING,
});

const setStateReportResponseToFailed = () => ({
  type: HTTP_REPORT_RESPONSE_FAILED,
});

const token = localStorage.getItem("token");

export const getMeetings = (filter) => {
  return async (dispatch) => {
    dispatch(setStateMeetingsToFetching());
    await doGetMeetings(dispatch, filter);
  };
};

const doGetMeetings = async (dispatch, filter) => {
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(server.MEETING_URL, { 
        params: {
          date: filter.date,
          year: filter.year,
          name: filter.name,
          location: filter.location,
          sequence: filter.sequence,
          page: filter.page,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      dispatch(setStateMeetingsToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateMeetingsToFailed());
    }
};


export const getMeetingById = (id) => {
  return async (dispatch) => {
    dispatch(setStateMeetingToFetching());
    
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`${server.MEETING_URL}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      
      let meetingResult = result.data
      dispatch(setStateMeetingToSuccess(meetingResult));
    } catch(err)  {
      dispatch(setStateMeetingToFailed());
    }
  };
};

export const deleteMeeting = (id) => {
  return async (dispatch) => {
    dispatch(setStateMeetingToFetching());
    const result = await httpClient.delete(
      `${server.MEETING_URL}/${id}`
    );
  };
};

export const getMeetingEvent = (meetingId, id) => {
  return async (dispatch) => {
    dispatch(setStateEventToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`/api/meetings/${meetingId}/event/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      dispatch(setStateEventToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateEventToFailed());
    }
  };
};

export const getMeetingAttendees = (meetingId) => {
  return async (dispatch) => {
    dispatch(setStateAttendeesToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`/api/meetings/${meetingId}/attendee`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      dispatch(setStateAttendeesToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateAttendeesToFailed());
    }
  };
};

export const getMeetingDocuments = (meetingId, folderId) => {
  return async (dispatch) => {
    dispatch(setStateDocumentsToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`/api/meetings/${meetingId}/documents/${folderId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      
      dispatch(setStateDocumentsToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateDocumentsToFailed());
    }
  };
};

export const getMeetingAttachments = (meetingId, folderId) => {
  return async (dispatch) => {
    dispatch(setStateAttachmentsToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`/api/meetings/${meetingId}/documents/${folderId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      
      dispatch(setStateAttachmentsToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateAttachmentsToFailed());
    }
  };
};

export const getMeetingReportResponse = (meetingId) => {
  return async (dispatch) => {
    dispatch(setStateReportResponseToFetching());
    const token = localStorage.getItem("token");
    
    try {
      const result = await httpClient.get(`/api/meetings/${meetingId}/attendee/confirm/response`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      dispatch(setStateReportResponseToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateReportResponseToFailed());
    }
  };
};

export const getTemplateFiles = () => {
  return async (dispatch) => {
    dispatch(setStateTemplatesToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.get(`/api/meetings/documents/templates`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      
      dispatch(setStateTemplatesToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateTemplatesToFailed());
    }
  };
};


export const deleteMeetingDocument = (meetingId, documentId) => {
  return async (dispatch) => {
    dispatch(setStateDocumentsToFetching());
    const token = localStorage.getItem("token");

    try {
      const result = await httpClient.delete(`/api/meetings/${meetingId}/documents/file/${documentId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      
      dispatch(setStateDocumentsToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateDocumentsToFailed());
    }
  };
};


